require('./tooltip.less');

let size = require('../../modules/size');

$(function() {
    var tooltips = {
        getTooltipContentTest: function() {
            return (
                '<div class="tooltipster__title">Преимущества регистрации</div>' +
                '<ol class="reg-benefits reg-benefits--black-text">' +
                '<li class="reg-benefits__item">Если вы косметолог, Вы можете покупать товары по <b>ОПТОВОЙ ЦЕНЕ!</b></li>' +
                '<li class="reg-benefits__item"><b>1000 РУБЛЕЙ</b> в&nbsp;подарок на первую покупку</li>' +
                '<li class="reg-benefits__item">Зарегистрируйтесь и получите электронную книгу в <b>ПОДАРОК!</b></li>' +
                '</ol>'
            );
        }
    };

    var defaultTooptipsOptions = {
        debug: false,
        contentAsHTML: true,
        interactive: true,
        maxWidth: 18 * size.defaultFontSize,
        repositionOnScroll: true,
        side: ['bottom', 'top'],
        trigger: 'custom',
        triggerOpen: {
            mouseenter: true,
            tap: true
        },
        triggerClose: {
            mouseleave: true,
            tap: true
        },
        updateAnimation: null
    };

    $(document).on('mouseenter click', '.js-tooltip:not(.tooltipstered)', function(e) {
        e.preventDefault();
        var $this = $(this);

        var func = tooltips[$this.data('tooltip-callback')];

        if ($.isFunction(func)) {
            $this
                .tooltipster(
                    $.extend({}, defaultTooptipsOptions, {
                        content: 'Загрузка...',
                        functionBefore: function(instance, helper) {
                            var $origin = $(helper.origin);

                            if ($origin.data('loaded') !== true) {
                                instance.content(func());
                                $origin.data('loaded', true);

                                //$.get('http://example.com/ajax.php', function(data) {
                                //	instance.content(data);
                                //	$origin.data('loaded', true);
                                //});
                            }
                        }
                    })
                )
                .tooltipster('open');
        } else {
            $this
                .tooltipster(
                    $.extend({}, defaultTooptipsOptions, {
                        content: $this.data('tooltip')
                    })
                )
                .tooltipster('open');
        }
    });
});



// WEBPACK FOOTER //
// ./blocks/tooltip/tooltip.js